import { ApprovalConsiderationAnnounceSevenComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceSevenComponent";
// import { ApprovalConsiderationAnnounceFiveComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceFiveComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function ApprovalConsiderationAnnounceSevenContainer() {
    const titleName = "รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-3)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ApprovalConsiderationAnnounceSevenComponent />
            <Footer />
        </div>
    )

}